class pdpSwiper extends HTMLElement {
  constructor() {
    super();
    this.options = this.getAttribute('data-swiper') ? JSON.parse(this.getAttribute('data-swiper')) : {};
    this.swiper;
  }

  connectedCallback() {
    this.initGallerySlider();
    this.zoomTrigger();
  }

  initGallerySlider() {
    const self = this;

    if (typeof Swiper !== 'undefined') {
      let galleryWrapper = this.querySelector('.swiper.gallery-swiper');
      this.swiper = new Swiper(galleryWrapper, self.options);

    
      this.swiper.on('init', function () {
        self.updateAriaHidden(this);
      });

      this.swiper.on('slideChange', function () {
        self.updateAriaHidden(this);
      });

      this.paginationThumbnail();
    }
  }

  updateAriaHidden(swiper) {
    swiper.slides.forEach((slide, index) => {
      const isActiveSlide = index === swiper.activeIndex;
      slide.setAttribute('aria-hidden', isActiveSlide ? 'false' : 'true');

      const interactiveElements = slide.querySelectorAll('button, [tabindex]');
      interactiveElements.forEach(el => {
        el.setAttribute('tabindex', isActiveSlide ? '0' : '-1');
      });
    });
  }

  paginationThumbnail() {
    let pagBullets = this.querySelectorAll('.swiper-pagination-thumbnail');
    pagBullets.forEach((bullet, index) => {
      let imgCloned = this.swiper.slides[index].querySelector('.product__modal-opener .product__media').cloneNode(true);
      if (imgCloned) {
        bullet.appendChild(imgCloned);
      }
    });
  }

  zoomTrigger() {
    const self = this;
    let zoomTrigger = this.querySelector('.zoom-trigger');
    zoomTrigger.addEventListener('click', function () {
      let slideToZoom = self.querySelector('.swiper-slide-active .product__media-toggle');
      if (slideToZoom) {
        slideToZoom.click();
      }
    });
  }
}

customElements.define('pdp-swiper', pdpSwiper);